<template>
    <div class="relative group">
        <input
            ref="input"
            :type="type"
            class="
                block border-gray-300 rounded-full w-full pr-8 shadow-sm
                focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50
            "
            :class="{'border-red-500': hasError, 'bg-gray-100 text-gray-500': readonly}"
            v-model="model"
            v-bind="$attrs"
            :readonly="readonly"/>
        <div
            v-if="suffix"
            ref="suffix"
            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            :class="{'group-hover:hidden': hasValue && clearable}">
            <span class="text-gray-500 sm:text-sm">{{ suffix }}</span>
        </div>
        <button v-if="hasValue && clearable"
                ref="clear"
                type="button"
                tabindex="-1"
                class="hidden group-hover:inline-block absolute inset-y-0 right-0 w-6 focus:outline-none"
                @click.prevent="model=''">
            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
        </button>
    </div>
</template>

<script>

import FormInput from "@/Mixins/FormInput";

export default {

    name: "Input",

    inheritAttrs: false,

    mixins: [FormInput],

    props: {
        type: {
            type: String,
            default: () => 'text'
        },
        readonly: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        suffix: String
    },

    methods: {
        mainElement() {
            return this.$refs.input;
        }
    }
};

</script>
